export const ACTIONS = {
  UPDATE_FIELD_VALUE: 'UPDATE_FIELD_VALUE',
  UPDATE_FIELD_ERRORS: 'UPDATE_FIELD_ERRORS',
  UPDATE_FORM_ERRORS: 'UPDATE_FORM_ERRORS',
  UPDATE_FORM_VALUES: 'UPDATE_FORM_VALUES',
}

const allFields = ['userName', 'password', 'isEULAaccepted'];

export const loginFormReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_FIELD_VALUE: {
      const { field, value } = action.payload;
      const updatedState = { ...state, [field]: { ...state[field], value } };
      return updatedState;
    }

    case ACTIONS.UPDATE_FIELD_ERRORS: {
      const { field, intl } = action.payload;
      const value = state[field].value;
      const errors = validateField({
        field, value, intl,
      });
      const updatedState = { ...state, [field]: { value, errors } };
      return updatedState;
    }

    case ACTIONS.UPDATE_FORM_ERRORS: {
      return action.payload.reduce((acc, curr) => {
        acc[curr.field] = { value: curr.value, errors: curr.errors }
        return acc;
      }, {});
    }

    case ACTIONS.UPDATE_FORM_VALUES: {
      const { data, intl } = action.payload;
      const updatedState = { ...state };

      allFields.forEach(field => {
        if (data[field]) {
          updatedState[field].value = data[field]
        }
      });

      allFields.forEach(field => {
        if (data[field]) {
          updatedState[field].errors = validateField({
            field, value: data[field], intl,
          });
        }
      });

      return updatedState;
    }

    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

export const initializeLoginFormState = () => {
  return {
    userName: { value: '', errors: [] },
    password: { value: '', errors: [] },
    isEULAaccepted: { value: false, errors: [] },
  }
};

const validateField = ({ field, value, intl }) => {
  const errors = [];

  if (field === 'userName') {
    if (value === '') {
      errors.push(intl.getI18nMessage('label.required.field'));
    } else if (value.length > 60) {
      errors.push(intl.getI18nMessage("label.user.details.textfields.helptext"));
    }
  }

  if (field === 'password') {
    if (value === '') {
      errors.push(intl.getI18nMessage('label.required.field'));
    }
  }

  if (field === 'isEULAaccepted' && value !== true) {
    errors.push(intl.getI18nMessage("label.user.account.setup.termsOfUse.helptext.error"));
  }

  return errors;
}

export const validateFormInputs = ({ state, intl }) => {
  let isFormValid = true;
  const validatedState = allFields.map(field => {
    const fieldErrors = validateField({
      field, value: state[field].value, intl,
    });
    if (fieldErrors.length > 0) {
      isFormValid = false;
    }
    return { field, value: state[field].value, errors: fieldErrors }
  })
  return { validatedState, isFormValid };
}